'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _react = require('react');

/**
 * Compares the modifiers in the components props to an array of modifier names that should have
 * the default modifiers applied to the children.
 * @param {object} props The component's props
 * @property {array} props.modifiers The modifiers applied to the component.
 * @param {array} modifiersRequiringDefaults These are the modifiers on the top component that
 *                                           require a default set of modifiers applied to the
 *                                           children.
 * @returns {boolean}
 */
function applyDefaultModifiersToChildren(_ref, modifiersRequiringDefaults) {
  var modifiers = _ref.modifiers;

  // `intersection` returns an array with the elements that appear in both arrays.
  return !!(modifiers && !(0, _lodash.isEmpty)((0, _lodash.intersection)(modifiers, modifiersRequiringDefaults)));
}

/**
 * Creates a batch of children with the appropriate default modifiers applied.
 * @param {object} props The component's props
 * @property {array} props.modifiers The modifiers applied to the component.
 * @property {node} props.modifiers The component's children
 * @param {array} modifiersRequiringDefaults These are the modifiers on the top component that
 *                                           require a default set of modifiers applied to the
 *                                           children.
 * @param {array} defaultModifiers These are the modifiers applied to the children if the top
 *                                 component is rendered with any of the modifiersRequiringDefaults
 * @returns {node} The component's _new_ children
 */
function childrenWithDefaultModifiers(props, modifiersRequiringDefaults, defaultModifiers) {
  // return the children as-is if no extra modifiers are required as defaults on the children.
  if (!applyDefaultModifiersToChildren(props, modifiersRequiringDefaults)) {
    return props.children;
  }
  // Prepend the default modifiers to ALL of the children's modifier arrays if the default
  // override is required. This order is critical, as it allows the developer to override
  // the defaults.
  return _react.Children.map(props.children, function (child) {
    var modifiers = (0, _lodash.concat)(defaultModifiers, child.props.modifiers);
    return (0, _react.cloneElement)(child, { modifiers: modifiers });
  });
}

exports.default = childrenWithDefaultModifiers;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/utils/childrenWithDefaultModifiers.js
// module id = 1541
// module chunks = 2